import { render } from "./FormColorPicker.vue?vue&type=template&id=899703b6"
import script from "./FormColorPicker.vue?vue&type=script&lang=js"
export * from "./FormColorPicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__